import React from "react";
import { Heading } from "@usap/uicomponents";
// 28px
export default function Heading1({ title = "", ...props }) {
  return (
    <Heading
      responsive={false}
      level={1}
      margin="0px"
      color="dark-2"
      {...props}
      dangerouslySetInnerHTML={{
        __html: title
      }}
    />
  );
}
